module.exports = __webpack_public_path__ + "img/sex-on-the-beach.7be52d8b.jpg";